import { useId } from "react";

export function SettingsGearIcon({ className = "", size = 18 }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
        stroke="currentColor"
        strokeWidth="1.75"
      />
      <path
        d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9c.26.604.852.997 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NlFlagIcon({ className = "" }) {
  return (
    <svg className={`locale-flag ${className}`.trim()} viewBox="0 0 21 15" aria-hidden="true">
      <rect width="21" height="15" rx="1.5" fill="#fff" />
      <rect width="21" height="5" fill="#ae1c28" />
      <rect y="10" width="21" height="5" fill="#21468b" />
    </svg>
  );
}

export function UsFlagIcon({ className = "" }) {
  const clipId = useId();

  return (
    <svg className={`locale-flag ${className}`.trim()} viewBox="0 0 21 15" aria-hidden="true">
      <defs>
        <clipPath id={clipId}>
          <rect width="21" height="15" rx="1.5" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clipId})`}>
        {Array.from({ length: 13 }, (_, index) => (
          <rect
            key={index}
            y={(index * 15) / 13}
            width="21"
            height={15 / 13}
            fill={index % 2 === 0 ? "#b22234" : "#fff"}
          />
        ))}
        <rect width="8.4" height="8.08" fill="#3c3b6e" />
        {[
          [1.2, 1.1],
          [3.2, 1.1],
          [5.2, 1.1],
          [7.2, 1.1],
          [2.2, 2.5],
          [4.2, 2.5],
          [6.2, 2.5],
          [1.2, 3.9],
          [3.2, 3.9],
          [5.2, 3.9],
          [7.2, 3.9],
          [2.2, 5.3],
          [4.2, 5.3],
          [6.2, 5.3],
          [1.2, 6.7],
          [3.2, 6.7],
          [5.2, 6.7],
          [7.2, 6.7],
        ].map(([cx, cy]) => (
          <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="0.42" fill="#fff" />
        ))}
      </g>
    </svg>
  );
}

export function LocaleFlag({ locale, className = "" }) {
  return locale === "en"
    ? <UsFlagIcon className={className} />
    : <NlFlagIcon className={className} />;
}
